export default "__VITE_ASSET__0c7083d8__"